import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import "../button/wow-button";
import { styles } from "./empty-state.css";

@customElement("wow-empty-state")
export class WowEmptyState extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  headline = "";

  @property({ type: String })
  subtitle = "";

  @property({ type: String, attribute: "button-text" })
  buttonText = "";

  override render() {
    return html`
      <div class="empty-state">
        <button class="icon-button" @click=${this.handleCtaClick} aria-label=${this.headline}>
          <slot name="icon"></slot>
        </button>
        <div class="text-content">
          ${this.headline ? html`<h2>${this.headline}</h2>` : nothing}
          ${this.subtitle ? html`<p>${this.subtitle}</p>` : nothing}
        </div>

        ${this.buttonText
          ? html` <wow-button variant="primary" @click=${this.handleCtaClick}> ${this.buttonText} </wow-button> `
          : nothing}
        <slot name="action"></slot>
      </div>
    `;
  }

  private handleCtaClick() {
    this.dispatchEvent(new CustomEvent("cta-click", { bubbles: true, composed: true }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-empty-state": WowEmptyState;
  }
}
